import { render, staticRenderFns } from "./EditProduction.vue?vue&type=template&id=52135021"
import script from "./EditProduction.vue?vue&type=script&lang=js"
export * from "./EditProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports